import React from "react";
import ite from "../../../assets/images/iti.png";
import "./index.scss"; // Assurez-vous que le chemin est correct
export const ITI = () => {
  return (
    <div className="ite mt-5">
      {" "}
      <div className="row ms-0 justify-content-center  gx-0 w-100 align-items-center mb-5 flex-column-reverse-mobile ">
        <div className="col-12 col-md-6 mx-auto d-flex justify-content-center align-items-center">
          <img src={ite} alt="ite" className="img-fluid" />
        </div>
        <div className="col-12 col-md-6 mx-auto  ">
          <div className="ite-title">Qu’est-ce que l’ITI ?</div>
          <div className="ite-text mt-3">
            L’ITI consiste à isoler les murs par l’intérieur à l’aide de plaques
            isolantes ou de doublages techniques.
          </div>
        </div>
      </div>
    </div>
  );
};
